import instanceQuery from '../../../graphql/queries/salesLedger/InvoiceConfigurationQuery.graphql';
import defaultQuery from '../../../graphql/queries/salesLedger/InvoiceConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/salesLedger/InvoiceConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/salesLedger/InvoiceConfigurationFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const InvoiceConfiguration: EntityType = {
  type: 'InvoiceConfig',
  title: 'Invoice Configuration',
  formTitle: 'Invoice Configuration',
  formUrl: '/Customers/Invoice/Configuration',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'SALES_LEDGER_INVOICE_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default InvoiceConfiguration;
